// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__xpe8c","hiddenSide":"layout_hiddenSide__MKfvm","layout__inner":"layout_layout__inner__nGG9o","container":"layout_container__LISqY"};